/** @prettier */

/**
 * CSVフォーマットエラーのダイアログ
 */

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import {useTranslation} from 'react-i18next';
//Style import
import '../css/common/common.css';
import {PrimaryButton} from './BasicButton';

/**
 * CSV差分比較エラーダイアログ
 * @param props props
 * @returns JSX
 * - open ダイアログを開く変数
 * - setOpen openのセット関数
 * - id ID
 */
const CSVNoDiffErrorMessage = (props: {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  id?: string;
}) => {
  const trans = useTranslation().t; //翻訳関数
  /**
   * OKボタン押下時処理
   */
  const handleClose = () => {
    props.setOpen(false);
  };

  return (
    <Dialog
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
      className="csvDiffErrorDialog">
      {/* タイトル */}
      <DialogTitle id="form-dialog-title" className="csvDiffErrorDialog__title">
        {trans('CSVNoDiffErrorMessage.title')}
      </DialogTitle>
      <DialogContent>
        {/* ダイアログに表示するメッセージ */}
        <DialogContentText>
          <p className="csvDiffErrorDialog__text">
            {trans('CSVNoDiffErrorMessage.message.fileError')}
          </p>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          onClick={handleClose}
          buttonText={trans('CSVNoDiffErrorMessage.button.ok')}
          id={props.id}
        />
      </DialogActions>
    </Dialog>
  );
};
export default CSVNoDiffErrorMessage;
